import type { SVGProps } from 'react';

const SignAllIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="edit-04">
      <path
        id="Icon"
        d="M15.75 13.4972L14.9999 14.3178C14.6021 14.7528 14.0626 14.9972 13.5001 14.9972C12.9376 14.9972 12.3981 14.7528 12.0003 14.3178C11.6019 13.8836 11.0625 13.6398 10.5001 13.6398C9.93778 13.6398 9.39835 13.8836 8.99998 14.3178M2.25 14.9972H3.50591C3.87279 14.9972 4.05624 14.9972 4.22887 14.9558C4.38192 14.9191 4.52824 14.8584 4.66245 14.7762C4.81382 14.6834 4.94354 14.5537 5.20296 14.2943L14.625 4.87224C15.2463 4.25092 15.2463 3.24356 14.625 2.62224C14.0037 2.00092 12.9963 2.00092 12.375 2.62224L2.95295 12.0443C2.69352 12.3037 2.5638 12.4334 2.47104 12.5848C2.3888 12.719 2.32819 12.8653 2.29145 13.0184C2.25 13.191 2.25 13.3745 2.25 13.7414V14.9972Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export default SignAllIcon;
